import { atom } from 'recoil';

export const timesheetConsultorAtom = atom<any>({
  key: 'timesheetConsultor',
  default: [],
});
